import BookmarksAndCollectionsPillNav from "molecules/pill-navs/bookmark-and-collections-pill-nav";
import React, { PropsWithChildren } from "react";
import MyBookmarksClearAll from "./options/my-bookmarks-clear-all";
import { UserBookmarkCountBy } from "models/enumerations/sorting/user-bookmarks/user-bookmark-count-by";

const CSS_CLASS_NAME = "c-my-bookmarks-grouped-by-layout";

interface MyBookmarksGroupedByLayoutProps extends PropsWithChildren {
    dropdowns?: JSX.Element;
    countBy: UserBookmarkCountBy;
}

const MyBookmarksGroupedByLayout = (props: MyBookmarksGroupedByLayoutProps) => {
    const { children, dropdowns, countBy } = props;
    return (
        <section className={CSS_CLASS_NAME}>
            <header className={`${CSS_CLASS_NAME}__header`}>
                <div className={`${CSS_CLASS_NAME}__pillWrapper`}>
                    <BookmarksAndCollectionsPillNav />
                </div>
                <div className={`${CSS_CLASS_NAME}__dropdownWrapper`}>
                    {dropdowns}
                </div>
                <div className={`${CSS_CLASS_NAME}__alertWrapper`}>
                    <MyBookmarksClearAll countBy={countBy} />
                </div>
            </header>
            <div className={`${CSS_CLASS_NAME}__main`}>{children}</div>
        </section>
    );
};

export default MyBookmarksGroupedByLayout;
